import React, { useEffect, useRef, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Collapse,
  styled,
  Box,
  useTheme,
} from "@mui/material";
import { NAV } from "../../config";
import Scrollbar from "../../components/scrollbar";
import TextLogo from "../../assets/img/logo/logo-text.svg";
import Image from "../../components/image";
import { useLocales } from "@/locales";
import { findMenuItemById } from "@/utils/until";
import { debounce } from "lodash";

const Logo = () => (
  <Image
    alt="ccpayment"
    src={TextLogo}
    scale={false}
    sx={{
      width: 185,
      height: 32,
      // borderRadius: 1,
      mx: "20px",
      mb: 3,
      flexShrink: 0,
      cursor: "pointer",
    }}
    onClick={() => {
      window.open("https://ccpayment.com", "_blank");
    }}
  />
);

function Index() {
  const { translate } = useLocales();
  const menuItems = [
    // api介绍
    {
      id: "introduction",
      title: translate("payment_api_introduction.title"),
      openIndex: ["introduction"],
      unfoldable: true,
    },
    // 快速指南
    {
      title: translate("quick_start.title1"),
      id: "quick-guide",
      openIndex: ["quick-guide"],
      children: [
        {
          title: translate("quick_start.start_title1"),
          id: "credentials",
          openIndex: ["quick-guide", "credentials"],
        },
        {
          title: translate("quick_start.title2"),
          id: "api-authentication-and-specifications",
          openIndex: ["quick-guide", "api-authentication-and-specifications"],
        },

        {
          title: translate("faq.call_protocol_rules_title"),
          id: "rules-for-api-calls",
          openIndex: ["quick-guide", "rules-for-api-calls"],
        },
        {
          title: translate("faq.visit_limit_title"),
          id: "request-limits",
          openIndex: ["quick-guide", "request-limits"],
        },
        {
          title: translate("faq.payment_access_process_title"),
          id: "api-flow-diagram",
          openIndex: ["quick-guide", "api-flow-diagram"],
          children: [
            {
              title: translate("faq.order_deposit_process"),
              id: "deposit-by-orders",
              openIndex: [
                "quick-guide",
                "api-flow-diagram",
                "deposit-by-orders",
              ],
            },
            {
              title: translate("faq.direct_address_recharge_process"),
              id: "deposit-by-permanent-addresses",
              openIndex: [
                "quick-guide",
                "api-flow-diagram",
                "deposit-by-permanent-addresses",
              ],
            },
            {
              title: translate("faq.withdrawal_process"),
              id: "withdrawal",
              openIndex: ["quick-guide", "api-flow-diagram", "withdrawal"],
            },
          ],
        },
      ],
    },
    // 测试网络
    {
      title: translate("sandbox_mode.title"),
      id: "testnet",
      openIndex: ["testnet"],
      unfoldable: true,
    },
    // webhook
    {
      title: translate("webhook_use.title"),
      id: "webhook",
      openIndex: ["webhook"],
      children: [
        {
          title: translate("webhook_use.webhook_guide"),
          id: "webhook-guide",
          openIndex: ["webhook", "webhook-guide"],
        },
        {
          title: translate("webhook_use.config_title"),
          id: "set-webhook-url",
          openIndex: ["webhook", "set-webhook-url"],
        },
        {
          title: translate("webhook_use.transfer_status_notifiy_title1"),
          id: "transaction-statuses-in-webhook",
          openIndex: ["webhook", "transaction-statuses-in-webhook"],
        },
        {
          title: translate("webhook_use.notifiy_step_title"),
          id: "how-to-handle-incoming-webhooks",
          openIndex: ["webhook", "how-to-handle-incoming-webhooks"],
        },
        {
          title: translate("webhook_use.retry_logic_title"),
          id: "retry-logic",
          openIndex: ["webhook", "retry-logic"],
        },
        {
          title: translate("webhook_use.view_list_retry_title1"),
          id: "view-webhook-notification-logs-and-resend-webhooks",
          openIndex: [
            "webhook",
            "view-webhook-notification-logs-and-resend-webhooks",
          ],
        },
        {
          title: translate("webhook_use.view_list_retry_title2"),
          id: "resend-webhook-by-calling-api",
          openIndex: ["webhook", "resend-webhook-by-calling-api"],
        },
      ],
    },
    // 支持与帮助
    {
      title: translate("support_help.support"),
      id: "support",
      openIndex: ["support"],
      children: [
        {
          title: "FAQ",
          id: "faq",
          openIndex: ["support", "faq"],
        },
        {
          title: translate("support_help.status_code_title"),
          id: "status-code",
          openIndex: ["support", "faq", "status-code"],
        },
        {
          title: translate("support_help.error_code_title"),
          id: "error-code",
          openIndex: ["support", "faq", "error-code"],
        },
        {
          title: translate("support_help.contact_us_title"),
          id: "contact-us",
          openIndex: ["support", "faq", "contact-us"],
        },
      ],
    },
    // 公共api
    {
      title: translate("public_resource.common_api"),
      id: "common-api",
      openIndex: ["common-api"],
      children: [
        {
          title: translate("public_resource.get_coin_list_title"),
          id: "get-token-list",
          openIndex: ["common-api", "get-token-list"],
        },
        {
          title: translate("public_resource.get_coin_info_title"),
          id: "get-token-information",
          openIndex: ["common-api", "get-token-information"],
        },
        {
          title: translate("public_resource.get_coin_price_title"),
          id: "get-token-price",
          openIndex: ["common-api", "get-token-price"],
        },
        {
          title: translate("public_resource.get_coin_list_res_table_desc_13"),
          id: "get-cwallet-user-information",
          openIndex: ["common-api", "get-cwallet-user-information"],
        },
        {
          title: translate("public_resource.get_coin_list_res_table_desc_8"),
          id: "get-withdrawal-network-fee",
          openIndex: ["common-api", "get-withdrawal-network-fee"],
        },
        {
          title: translate("public_resource.get_coin_list_res_table_desc_1"),
          id: "get-fiat-list",
          openIndex: ["common-api", "get-fiat-list"],
        },
      ],
    },
    // api list
    {
      title: translate("public_resource.title"),
      id: "api-domumentation",
      openIndex: ["api-domumentation"],
      children: [
        {
          title: translate("merchant_app_mode_API.text_2"),
          id: "balance-query-apis",
          openIndex: ["api-domumentation", "balance-query-apis"],
          children: [
            {
              title: translate("merchant_app_mode_API.text_3"),
              id: "get-balance-list",
              openIndex: [
                "api-domumentation",
                "balance-query-apis",
                "get-balance-list",
              ],
            },
            {
              title: translate("merchant_app_mode_API.text_6"),
              id: "get-coin-balance",
              openIndex: [
                "api-domumentation",
                "balance-query-apis",
                "get-coin-balance",
              ],
            },
          ],
        },
        {
          title: translate("merchant_app_mode_API.text_8"),
          id: "deposit-apis",
          openIndex: ["api-domumentation", "deposit-apis"],
          children: [
            {
              title: translate("merchant_app_mode_API.text_9"),
              id: "create-deposit-address-for-order",
              openIndex: [
                "api-domumentation",
                "deposit-apis",
                "create-deposit-address-for-order",
              ],
              children: [
                {
                  title: translate("merchant_app_mode_API.text_27"),
                  id: "webhook-for-api-deposit",
                  openIndex: [
                    "api-domumentation",
                    "deposit-apis",
                    "create-deposit-address-for-order",
                    "webhook-for-api-deposit",
                  ],
                },
                {
                  title: translate("merchant_app_mode_API.text_30"),
                  id: "get-order-information",
                  openIndex: [
                    "api-domumentation",
                    "deposit-apis",
                    "create-deposit-address-for-order",
                    "get-order-information",
                  ],
                },
              ],
            },
            {
              title: translate("merchant_app_mode_API.text_49"),
              id: "get-permanent-deposit-address",
              openIndex: [
                "api-domumentation",
                "deposit-apis",
                "get-permanent-deposit-address",
              ],
              children: [
                {
                  title: translate("merchant_app_mode_API.text_54"),
                  id: "webhook-for-direct-deposit",
                  openIndex: [
                    "api-domumentation",
                    "deposit-apis",
                    "get-permanent-deposit-address",
                    "webhook-for-direct-deposit",
                  ],
                },
              ],
            },
            {
              title: translate("merchant_app_mode_API.text_57"),
              id: "get-deposit-record",
              openIndex: [
                "api-domumentation",
                "deposit-apis",
                "get-deposit-record",
              ],
            },
            {
              title: translate("merchant_app_mode_API.text_61"),
              id: "get-deposit-record-list",
              openIndex: [
                "api-domumentation",
                "deposit-apis",
                "get-deposit-record-list",
              ],
            },
          ],
        },
        {
          title: translate("merchant_app_mode_API.text_67"),
          id: "withdrawal-api",
          openIndex: ["api-domumentation", "withdrawal-api"],
          children: [
            {
              title: translate("merchant_app_mode_API.text_68"),
              id: "create-network-withdrawal-order",
              openIndex: [
                "api-domumentation",
                "withdrawal-api",
                "create-network-withdrawal-order",
              ],
              children: [
                {
                  title: translate("merchant_app_mode_API.text_72"),
                  id: "webhook-for-api-withdrawal",
                  openIndex: [
                    "api-domumentation",
                    "withdrawal-api",
                    "create-network-withdrawal-order",
                    "webhook-for-api-withdrawal",
                  ],
                },
              ],
            },
            {
              title: translate("merchant_app_mode_API.text_74"),
              id: "withdrawal-to-cwallet-account",
              openIndex: [
                "api-domumentation",
                "withdrawal-api",
                "withdrawal-to-cwallet-account",
              ],
            },
            {
              title: translate("merchant_app_mode_API.text_76"),
              id: "get-withdrawal-record",
              openIndex: [
                "api-domumentation",
                "withdrawal-api",
                "get-withdrawal-record",
              ],
            },
            {
              title: translate("merchant_app_mode_API.text_82"),
              id: "get-withdrawal-record-list",
              openIndex: [
                "api-domumentation",
                "withdrawal-api",
                "get-withdrawal-record-list",
              ],
            },
          ],
        },
      ],
    },
    //create a wallet
    {
      title: translate("merchant_user_wallet_mode_API.title"),
      id: "create-a-wallet-system",
      openIndex: ["create-a-wallet-system"],
      children: [
        {
          title: translate("merchant_user_wallet_mode_API.title_1"),
          id: "user-asset-inquiry",
          openIndex: ["create-a-wallet-system", "user-asset-inquiry"],
          children: [
            {
              title: translate("merchant_user_wallet_mode_API.title_1_1"),
              id: "get-a-list-of-user-assets",
              openIndex: [
                "create-a-wallet-system",
                "user-asset-inquiry",
                "get-a-list-of-user-assets",
              ],
            },
            {
              title: translate("merchant_user_wallet_mode_API.title_2"),
              id: "acquisition-of-user-token-assets",
              openIndex: [
                "create-a-wallet-system",
                "user-asset-inquiry",
                "acquisition-of-user-token-assets",
              ],
            },
          ],
        },
        {
          title: translate("merchant_user_wallet_mode_API.title_3"),
          id: "user-recharge-related-apis",
          openIndex: ["create-a-wallet-system", "user-recharge-related-apis"],
          children: [
            {
              title: translate("merchant_user_wallet_mode_API.title_3_1"),
              id: "get-or-create-a-user-address",
              openIndex: [
                "create-a-wallet-system",
                "user-recharge-related-apis",
                "get-or-create-a-user-address",
              ],
              children: [
                {
                  title: translate("merchant_user_wallet_mode_API.text_6"),
                  id: "webhook-notifications-user-deposit",
                  openIndex: [
                    "create-a-wallet-system",
                    "user-recharge-related-apis",
                    "get-or-create-a-user-address",
                    "webhook-notifications-user-deposit",
                  ],
                },
              ],
            },
            {
              title: translate("merchant_user_wallet_mode_API.text_12"),
              id: "get-user-recharge-records",
              openIndex: [
                "create-a-wallet-system",
                "user-recharge-related-apis",
                "get-user-recharge-records",
              ],
            },
            {
              title: translate("merchant_user_wallet_mode_API.text_26"),
              id: "get-user-recharge-history",
              openIndex: [
                "create-a-wallet-system",
                "user-recharge-related-apis",
                "get-user-recharge-history",
              ],
            },
          ],
        },
        {
          title: translate("merchant_user_wallet_mode_API.text_39"),
          id: "apis-related-to-user-withdrawals",
          openIndex: [
            "create-a-wallet-system",
            "apis-related-to-user-withdrawals",
          ],
          children: [
            {
              title: translate("merchant_user_wallet_mode_API.text_40"),
              id: "user-withdrawals-to-blockchain",
              openIndex: [
                "create-a-wallet-system",
                "apis-related-to-user-withdrawals",
                "user-withdrawals-to-blockchain",
              ],
              children: [
                {
                  title: translate("merchant_user_wallet_mode_API.text_47"),
                  id: "webhook-notifications-user-withdrawal",
                  openIndex: [
                    "create-a-wallet-system",
                    "apis-related-to-user-withdrawals",
                    "user-withdrawals-to-blockchain",
                    "webhook-notifications-user-withdrawal",
                  ],
                },
              ],
            },
            {
              title: translate("merchant_user_wallet_mode_API.text_52"),
              id: "user-withdrawals-to-cwallet-account",
              openIndex: [
                "create-a-wallet-system",
                "apis-related-to-user-withdrawals",
                "user-withdrawals-to-cwallet-account",
              ],
            },
            {
              title: translate("merchant_user_wallet_mode_API.text_57"),
              id: "get-user-withdrawal-records",
              openIndex: [
                "create-a-wallet-system",
                "apis-related-to-user-withdrawals",
                "get-user-withdrawal-records",
              ],
            },
            {
              title: translate("merchant_user_wallet_mode_API.text_72"),
              id: "get-user-withdrawal-history",
              openIndex: [
                "create-a-wallet-system",
                "apis-related-to-user-withdrawals",
                "get-user-withdrawal-history",
              ],
            },
          ],
        },
        {
          title: translate("merchant_user_wallet_mode_API.text_77"),
          id: "apis-related-to-user-transfers",
          openIndex: [
            "create-a-wallet-system",
            "apis-related-to-user-transfers",
          ],
          children: [
            {
              title: translate("merchant_user_wallet_mode_API.text_78"),
              id: "initiate-user-transfers",
              openIndex: [
                "create-a-wallet-system",
                "apis-related-to-user-transfers",
                "initiate-user-transfers",
              ],
            },
            {
              title: translate("merchant_user_wallet_mode_API.text_84"),
              id: "get-user-transfer-records",
              openIndex: [
                "create-a-wallet-system",
                "apis-related-to-user-transfers",
                "get-user-transfer-records",
              ],
            },
            {
              title: translate("merchant_user_wallet_mode_API.text_93"),
              id: "get-user-transfer-history",
              openIndex: [
                "create-a-wallet-system",
                "apis-related-to-user-transfers",
                "get-user-transfer-history",
              ],
            },
          ],
        },
      ],
    },
  ];

  const scrollbarRef = useRef<any>(null);
  const [hash, setHash] = useState<string>("");

  useEffect(() => {
    let currentLang_ = "en";
    const searchParams = window.location.search;
    if (searchParams) {
      let new_searchParams = searchParams.replace("?", "").replace("/", "");
      currentLang_ = new_searchParams;
    } else {
      currentLang_ = "en";
    }

    setHash(window.location.hash || `?${currentLang_}#introduction`);
    // eslint-disable-next-line
  }, []);

  const flatMenu = (menuItems: any[]) => {
    const arr: any[] = [];
    menuItems.forEach((item) => {
      arr.push(item.id);
      if (item?.children) {
        arr.push(...flatMenu(item.children));
      }
    });
    return arr;
  };

  const findNodeById = () => {
    const arr = flatMenu(menuItems);
    const nodeArr = arr.map((item, i) => {
      const h = document.getElementById(`${item}`) as HTMLDivElement;
      let hh = h?.offsetTop || 0;
      if (h?.offsetParent?.className.includes("sticky")) {
        hh = (h.offsetParent as HTMLDivElement)?.offsetTop || 0;
      }
      return { id: item, h: hh };
    });
    return nodeArr;
  };

  const handleScroll = debounce((e: any) => {
    const scrollTop = e.target.scrollTop;

    const arr = findNodeById().filter((item, i) => i === 0 || item.h !== 0);
    for (let i = 0; i < arr.length; i++) {
      if (scrollTop === 0) {
        window.history.pushState({}, "", `#${arr[i].id}`);
        setHash(`#${arr[i].id}`);
        break;
      }

      if (
        (i > 0 && arr[i].h === scrollTop) ||
        (i === arr.length - 1 && scrollTop >= arr[i].h)
      ) {
        window.history.pushState({}, "", `#${arr[i].id}`);
        setHash(`#${arr[i].id}`);
        break;
      }
      // 如果这个id对应的滚动高度大于实际滚动高度
      if (i > 0 && arr[i].h > scrollTop && arr[i - 1].h < scrollTop) {
        //解决部分item listy因为高度选中不了的问题
        if (window.location.hash === `#${arr[i].id}`) {
          window.history.pushState({}, "", `#${arr[i].id}`);
          setHash(`#${arr[i].id}`);
          break;
        }
        window.history.pushState({}, "", `#${arr[i - 1].id}`);
        setHash(`#${arr[i - 1].id}`);
        break;
      }
    }
  }, 0.01 * 1000);

  useEffect(() => {
    const scrollable = document.querySelector("#test-scroll") as HTMLDivElement;

    if (scrollable) {
      scrollable.addEventListener("scroll", handleScroll);
    }

    return () => scrollable?.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line
  }, []);

  return (
    <NavWrap>
      <Logo />
      <Scrollbar ref={scrollbarRef} sx={{ paddingBottom: "80px" }}>
        <TreeView
          hash={hash}
          setHash={(v) => {
            setHash(v);
          }}
          menuItems={menuItems}
        />
      </Scrollbar>
    </NavWrap>
  );
}

const NavWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: NAV.W_DASHBOARD,
  background:
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[900],
  padding: "32px 0 0px",
  height: "100%",
  overflow: "hidden",
  position: "fixed",
  top: 0,
  left: 0,
}));

interface MenuItem {
  unfoldable?: boolean;
  title: string;
  id: string;
  openIndex?: string[];
  children?: MenuItem[];
}

const TreeView: React.FC<{
  menuItems: MenuItem[];
  hash: string;
  setHash: (v: string) => void;
}> = ({ menuItems, hash, setHash }) => {
  const [openIndexes, setOpenIndexes] = useState<string[]>([]);
  const theme = useTheme();
  const [click, setClick] = useState<boolean>(false);

  useEffect(() => {
    getByIndex(hash);
    // eslint-disable-next-line
  }, []);

  const initHome = () => {
    const searchParams = window.location.search;
    if (searchParams) {
      let new_searchParams = searchParams.replace("?", "").replace("/", "");
      window.history.pushState({}, "", `?${new_searchParams}#introduction`);
    } else {
      window.history.pushState({}, "", `?en#introduction`);
    }
  };

  const getByIndex = (hash_: string) => {
    if (hash_) {
      const stringWithoutHash = hash_.replace(/#/g, "");
      scrollToView(stringWithoutHash);
      let findItem = findMenuItemById(menuItems, stringWithoutHash);
      if (findItem?.openIndex) {
        //左侧导航展开
        handleItemClick(stringWithoutHash, findItem.openIndex);
        //左侧导航高亮
        setHash(hash_);
      } else {
        initHome();
      }
    }
  };

  const scrollToView = (stringWithoutHash: string) => {
    const anchorElement = document.getElementById(stringWithoutHash);
    // 找到锚点 滚动到相应位置
    if (anchorElement) {
      anchorElement.scrollIntoView({ behavior: "smooth" });
    } else {
      console.log("未找到锚点ID:", stringWithoutHash);
    }
  };

  const handleToClick = (hash_: string) => {
    const searchParams = window.location.search;
    if (searchParams) {
      let new_searchParams = searchParams.replace("?", "").replace("/", "");
      const a = document.createElement("a");
      a.href = `?${new_searchParams}#${hash_}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
    }
  };

  const handleRouteChange = (hash_: string) => {
    //设置点击高亮样式
    const stringWithoutHash = hash_.replace(/#/g, "");
    //解决地址栏空值无限循环加载
    if (stringWithoutHash !== "introduction") {
      handleToClick(stringWithoutHash);
    }
    let findItem = findMenuItemById(menuItems, stringWithoutHash);
    if (findItem?.openIndex) {
      //解决单击变双击的问题
      if (click) return;
      //左侧导航展开
      handleItemClick(stringWithoutHash, findItem.openIndex);
      //左侧导航高亮
      // setHash(window.location.hash);
    } else {
      initHome();
    }
  };

  useEffect(() => {
    setClick(false);
    handleRouteChange(window.location.hash);
    // eslint-disable-next-line
  }, [hash]);

  const handleItemClick = (id: string, openIndex?: string[]) => {
    let openIds = [...openIndexes, id];
    if (openIndex) {
      openIds = [...openIndexes, ...openIndex, id];
    }
    if (openIndexes.includes(id)) {
      setOpenIndexes(openIndexes.filter((i) => i !== id));
    } else {
      setOpenIndexes(openIds);
    }
  };

  const renderMenuItems = (items: MenuItem[], path: number[] = []) => {
    return items.map((item, index) => {
      const itemPath = [...path, index];
      const isOpen = openIndexes.includes(item.id);
      return (
        <div key={item.id}>
          <ListItem
            onClick={() => {
              setClick(true);
              handleItemClick(item.id, item?.openIndex);
            }}
            sx={{
              ":hover": {
                background: "#E4EEFD",
                borderRadius: "8px",
              },
              padding: 0,
            }}
          >
            <a
              href={`?${
                window.location.search
                  ? window.location.search.replace("?", "").replace("/", "")
                  : "en"
              }#${item.id}`}
              onClick={(e) => {
                if (hash === item.id) {
                  e.stopPropagation();
                  e.preventDefault();
                }
              }}
              style={{
                width: "100%",
                height: "44px",
                display: "flex",
                textDecoration: "none",
                overflow: "hidden",
                padding: "10px 6px",
                paddingLeft: item?.unfoldable ? "40px" : "6px",
                color:
                  hash === `#${item.id}`
                    ? theme.palette.primary.main
                    : theme.palette.text.primary,
              }}
            >
              {item.children && (
                <span
                  className="ic icon-arrow-down"
                  style={{
                    fontSize: "16px",
                    transform: `rotate(${isOpen ? "0deg" : "-90deg"})`,
                    transition: "all 0.15s cubic-bezier(0.31, 0.57, 0.56, 1)",
                    marginRight: "8px",
                    padding: "4px",
                  }}
                />
              )}
              <ListItemText
                primary={item.title}
                sx={{
                  span: {
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    width: "100%",
                  },
                }}
              />
            </a>
          </ListItem>
          {item.children && isOpen && (
            <Collapse
              sx={{ marginLeft: 4 }}
              in={isOpen}
              timeout="auto"
              unmountOnExit
            >
              {renderMenuItems(item.children, itemPath)}
            </Collapse>
          )}
        </div>
      );
    });
  };
  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      sx={{
        padding: "8px 12px",
      }}
    >
      {renderMenuItems(menuItems)}
    </List>
  );
};

export default Index;
